// Reset window scroll on normal Turbo visits (e.g. product show), but keep
// storefront catalog filter navigations on the items section.
const intentionalAnchors = new Set([
  'search-results',
  'category-shelf',
  'shop-directory',
  'shop-catalog-items',
  'shop-by-brand'
])

let previousUrl = new URL(window.location.href)

function shopStorefrontPath (pathname) {
  return /^\/s\/[^/]+\/?$/.test(pathname) ||
    /^\/marketplace\/shops\/[^/]+\/?$/.test(pathname)
}

function shouldKeepScrollPosition (destination = window.location) {
  const visit = window.Turbo?.navigator?.currentVisit
  if (visit?.action === 'restore') return true

  const url = destination instanceof URL ? destination : new URL(destination.href || window.location.href)
  const hash = url.hash.replace(/^#/, '')
  if (hash && intentionalAnchors.has(hash)) return true

  const anchor = url.searchParams.get('anchor')
  if (anchor && intentionalAnchors.has(anchor)) return true

  // Brand / shelf / search filters on the same shop page - stay near catalog.
  if (shopStorefrontPath(url.pathname) && previousUrl.pathname === url.pathname) {
    return true
  }

  return false
}

function scrollShopCatalogIntoView () {
  const target = document.getElementById('shop-catalog-items')
  if (!target) return

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
  target.scrollIntoView({
    behavior: reduceMotion ? 'auto' : 'smooth',
    block: 'start'
  })
}

function scrollWindowToTop () {
  if (shouldKeepScrollPosition()) {
    if (shopStorefrontPath(window.location.pathname) &&
        (window.location.search.includes('brand=') ||
         window.location.search.includes('category_id=') ||
         window.location.search.includes('q='))) {
      scrollShopCatalogIntoView()
    }
    return
  }

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: reduceMotion ? 'auto' : ('instant' in document.documentElement.style ? 'instant' : 'auto')
  })
}

document.addEventListener('turbo:before-visit', (event) => {
  previousUrl = new URL(window.location.href)
  const next = new URL(event.detail.url, window.location.origin)
  // Stash for turbo:load in case location isn't updated yet in some browsers.
  window.__ebazzariPreviousUrl = previousUrl
  window.__ebazzariNextUrl = next
})

document.addEventListener('turbo:load', () => {
  if (window.__ebazzariPreviousUrl) previousUrl = window.__ebazzariPreviousUrl
  scrollWindowToTop()
  window.requestAnimationFrame(scrollWindowToTop)
})

document.addEventListener('turbo:frame-load', (event) => {
  if (event.target?.id !== 'shop_catalog') return
  if (!shopStorefrontPath(window.location.pathname)) return
  if (!(window.location.search.includes('brand=') ||
        window.location.search.includes('category_id=') ||
        window.location.search.includes('q='))) return

  window.requestAnimationFrame(scrollShopCatalogIntoView)
})

document.addEventListener('turbo:before-cache', () => {
  if (shopStorefrontPath(window.location.pathname)) return
  window.scrollTo(0, 0)
})
